import { render, staticRenderFns } from "./attachment-cards.vue?vue&type=template&id=41a31ff0&scoped=true&"
import script from "./attachment-cards.vue?vue&type=script&lang=ts&"
export * from "./attachment-cards.vue?vue&type=script&lang=ts&"
import style0 from "./attachment-cards.vue?vue&type=style&index=0&id=41a31ff0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41a31ff0",
  null
  
)

export default component.exports